import { Modal } from 'react-bootstrap';
import useCommonStore from 'store/common';
import {
	AddCertifications,
	AddCoverImage,
	AddEducation,
	AddExperience,
	AddLanguage,
	AddProfileImage,
	AddProjects,
	AddSkills,
	EditAboutUs,
	EditCompanyAboutUs,
	EditCompanyDetails,
	EditPersonalDetails,
	EditResume,
	EditVideoResume,
	VideoPlayer,
} from './ProfileEditModal';
import {
	AddStory,
	ConfirmModal,
	AssessementSuccess,
	CarouselModal,
	CreateNewPost,
	DeleteModal,
	JobAlert,
	LoginModal,
	PostLikedBy,
	RejectCandidateModal,
	ReportFeeds,
	SharePost,
	SocialStoryPreview,
	TwoFactorAuthentication,
	VerifyMobileNumber,
	ScheduleMeeting,
	ScheduleMeetingCompanyModal,
	AddAdvertisement,
	WaitingPage,
	SubscriptionModal,
	SubscriptionAlert,
	ConnectionList,
	FollowingList,
} from './Common';
import { SuccessModal } from 'pages/PostNewJob/SuccessModal';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './styles.scss';
import { setPostLikedUsers } from 'store/feeds';
import SignUpProfileCropper from './Common/SignUpProfileCropper';
import SubscriptionAlertForPostJob from './Common/SubscriptionModal/SubscriptionAlertForPostJob';
import FollowersList from './Common/FollowersList';
import NotificationDetail from 'components/NotificationDetail';

const CommonModal = () => {
	const { modalConfig = {}, hideCommonModal }: any = useCommonStore((state) => state);
	const location = useLocation();
	const modalBodyContent: any = {
		saveJobAlert: <JobAlert />,
		confirmModal: <ConfirmModal />,
		loginModal: <LoginModal />,
		signUpProfileCropper: <SignUpProfileCropper />,
		deleteModal: <DeleteModal />,
		successAssessmentModal: <AssessementSuccess />,
		twoFactorAuthentication: <TwoFactorAuthentication />,
		rejectModal: <RejectCandidateModal id={modalConfig?.id} />,
		addExperience: <AddExperience />,
		addEducation: <AddEducation />,
		addAcademic: <AddProjects />,
		addCertificate: <AddCertifications />,
		addSkill: <AddSkills />,
		addLanguage: <AddLanguage />,
		editAboutUs: <EditAboutUs />,
		editResume: <EditResume />,
		editVideoResume: <EditVideoResume />,
		videoPlayer: <VideoPlayer />,
		editPersonalDetails: <EditPersonalDetails />,
		subscriptionModal: <SubscriptionModal />,
		subscriptionAlert: <SubscriptionAlert />,
		subscriptionAlertForPostJob: <SubscriptionAlertForPostJob />,

		// Company
		editCompanyAboutUs: <EditCompanyAboutUs />,
		editCompanyDetails: <EditCompanyDetails />,

		addProfileImage: <AddProfileImage />,
		addCoverImage: <AddCoverImage />,
		verifyMobileNumber: <VerifyMobileNumber />,
		successModal: <SuccessModal />,
		createNewPost: <CreateNewPost />,
		postLikedBy: <PostLikedBy />,
		carouselModal: <CarouselModal />,
		addStory: <AddStory />,
		socialStoryPreview: <SocialStoryPreview />,
		reportFeeds: <ReportFeeds />,
		postShare: <SharePost />,
		meetingScheduleModal: <ScheduleMeeting />,
		meetingScheduleModalCompany: <ScheduleMeetingCompanyModal />,
		addAdvertisement: <AddAdvertisement />,
		waitingPage: <WaitingPage />,
		connectionsList: <ConnectionList />,
		followersList: <FollowersList />,
		followingList: <FollowingList />,
		notificationDetail: <NotificationDetail />,
	};

	useEffect(() => {
		if (!modalConfig?.visible) {
			setPostLikedUsers([]);
		}
	}, [modalConfig?.visible]);

	useEffect(() => {
		if (modalConfig?.visible) {
			hideCommonModal();
		}
	}, [location?.pathname]);

	const handleClose = () => {
		if (modalConfig?.onClose) {
			modalConfig.onClose();
			return;
		}
		hideCommonModal();
	};

	return (
		<Modal
			className={
				['meetingScheduleModal', 'meetingScheduleModalCompany'].includes(modalConfig.type)
					? 'edit-modal schedule-meeting'
					: 'edit-modal'
			}
			show={modalConfig?.visible}
			onHide={handleClose}
			size="sm"
			backdrop="static"
			centered
			{...modalConfig?.props}
		>
			<Modal.Header className="p-0 m-0 border-0"></Modal.Header>
			{modalBodyContent[modalConfig?.type]}
		</Modal>
	);
};

export default CommonModal;
